import { P6Instance } from "#models/site-primavera";
import { P6Service } from "#services/api/p6.service";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { Subject, takeUntil } from "rxjs";

@Component({
    selector: "app-create-p6-instance",
    templateUrl: "./create-p6-instance.component.html",
    standalone: false
})
export class CreateP6InstanceComponent implements OnDestroy {
  p6InstanceForm: FormGroup = new FormGroup({
    Name: new FormControl(null, Validators.required),
  });

  @Input() visible: boolean = false;

  @Output() p6InstanceCreated = new EventEmitter<P6Instance>();

  private _destroy$ = new Subject<boolean>();

  constructor(
    private readonly _p6Service: P6Service,
    private _messageSvc: MessageService,
    private _translateSvc: TranslateService
  ) {}

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  onVisibleChange(isVisible: boolean) {
    this.visible = isVisible;
    if (!isVisible) {
      this.p6InstanceCreated.emit(null);
    }
  }

  onCancel() {
    this.visible = false;
    this.p6InstanceCreated.emit(null);
  }

  onSubmit() {
    const payload: P6Instance = new P6Instance();
    payload.InstanceName = this.p6InstanceForm.get("Name").value;
    this._p6Service
      .createP6Instance(payload)
      .pipe(takeUntil(this._destroy$))
      .subscribe((p6Instance: P6Instance) => {
        this.p6InstanceForm.reset();
        this.visible = false;
        this.p6InstanceCreated.emit(p6Instance);
        this._messageSvc.add({
          severity: "success",
          summary: this._translateSvc.instant("common.success") + "!",
          detail: this._translateSvc.instant("components.p6Instance.created"),
          life: 5000,
        });
      });
  }
}
